import { SET_ACTIVATION_EMAIL, SET_IS_RESTRICTED_USER, SET_USER_INFO } from 'common/actions/auth/types';
import { setActivationEmail, setIsRestrictedUser, setUserInfo } from './authReducers';

export default {
  [SET_USER_INFO]: setUserInfo,
  [SET_ACTIVATION_EMAIL]: setActivationEmail,
  [SET_IS_RESTRICTED_USER]: setIsRestrictedUser,
};
